import {
    Configuration
  } from '../../../../../core';

  export const dispatchType =  {
    searchText: 'Buscar tipo de despacho',
    addText: '',
    export: false,
    filter: false,
    filterDefault: '',
    disabled: false,
    partialField: '',
    selectedRow: true,
    columns: [
      {
        title: 'Código',
        name: 'id',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: Configuration) => element.id.toString().padStart(4, '0')
      },
      {
        title: 'Tipo de despacho',
        name: 'name',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: Configuration) => `${element.configName} - ${element.configDescription}`
      },      
      {
        title: 'Despacho primario',
        name: 'level',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: Configuration) => element.configMetadata.level ? 'Activo' : 'Inactivo'
      },
      {
        title: 'Despacha feriados',
        name: 'check',
        type: 'boolean',
        editable: true,
        checkAll: false,
        class: 'left',
        value: (element: Configuration) => element.configMetadata.check
      },
      {
        title: 'Despacha el mismo día',
        name: 'dispatchToday',
        type: 'boolean',
        editable: true,
        checkAll: false,
        class: 'left',
        value: (element: Configuration) => element.configMetadata.dispatchToday
      },
      {
        title: 'Activo',
        name: 'active',
        type: 'boolean',
        editable: true,
        checkAll: false,
        class: 'left',
        value: (element: Configuration) => element.active
      }
    ],
    subTable: {}
  };
